'use client';

import type { ReactNode } from 'react';

interface RecircPromoCardProps {
  fallback: ReactNode;
  module?: 'latest' | 'most-popular';
}

export const RecircPromoCard = ({ fallback, module = 'latest' }: RecircPromoCardProps) => {
  return (
    <div className='group relative w-full'>
      <div
        className='hidden w-full items-start justify-center [&_iframe]:ml-0 has-[.tp-container-inner]:flex'
        id={`promo-piano-template-recirc-card-container-${module}`}
      />
      <div className='group-has-[.tp-container-inner]:hidden'>{fallback}</div>
    </div>
  );
};
